module.exports = __webpack_public_path__ + "img/kyle-wong.21a7c14c.png";